module.exports = __webpack_public_path__ + "static/biennale-book-it-53ddfd2ff44ce94220f9cf4996f70fcb.otf";